"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatFeedListResponseSchema = exports.chatFeedListQuerySchema = exports.chatFeedItemSchema = exports.chatFeedChannelSchema = exports.chatFeedCategorySchema = exports.chatFeedResourceSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
exports.chatFeedResourceSchema = zod_1.z.enum([
    "CONVERSATION",
    "JOB_INBOX",
    "VOICE_CALL",
]);
exports.chatFeedCategorySchema = zod_1.z.enum([
    "CUSTOMER",
    "TEAM",
    "JOB_INBOX",
    "VOICE",
]);
exports.chatFeedChannelSchema = zod_1.z.enum([
    "EMAIL",
    "SMS",
    "WEB_CHAT",
    "MESSAGING",
    "TEAM",
    "JOB_INBOX",
    "VOICE",
]);
exports.chatFeedItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    resource: exports.chatFeedResourceSchema,
    category: exports.chatFeedCategorySchema,
    channel: exports.chatFeedChannelSchema,
    source: zod_1.z.string().min(1).max(80),
    status: zod_1.z.string().min(1).max(40),
    title: zod_1.z.string().min(1).max(240),
    preview: zod_1.z.string().nullable(),
    contactName: zod_1.z.string().nullable(),
    assignedToMembershipId: zod_1.z.string().uuid().nullable(),
    assignedToName: zod_1.z.string().nullable(),
    unreadCount: zod_1.z.number().int().nonnegative(),
    activityAt: zod_1.z.string().datetime({ offset: true }),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
const queryBooleanSchema = zod_1.z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional();
exports.chatFeedListQuerySchema = pagination_1.paginationQuerySchema.extend({
    search: zod_1.z.string().trim().max(160).optional(),
    category: exports.chatFeedCategorySchema.optional(),
    channel: exports.chatFeedChannelSchema.optional(),
    assignedToMembershipId: zod_1.z.string().uuid().optional(),
    unassigned: queryBooleanSchema,
    unread: queryBooleanSchema,
});
exports.chatFeedListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.chatFeedItemSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema,
});
//# sourceMappingURL=chat-feed.js.map